import React from 'react'

import TextField from '@material-ui/core/TextField';
import {FormHelperText} from "@material-ui/core";

import FileUploader from '../../common/FileUploader'

import Backend from '../../../utils/Backend'
import AuthManager from '../../../utils/AuthManager'

export default class File extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: props.data,
      index: props.index
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps)
  }

  render() {
    let { data, index } = this.state

    let className = "field-file "
      className += data.is_required ? "validate-required" : ""
    if(data.error){
      className += " validation-error"
    }

    return (
      <div className={className}>
        <FileUploader
          key={data.answer?.file?.id}
          placeholder={data.title}
          endpoint={window.Api.Files}
          params={{website_id: window.CURRENT_WEBSITE_ID}}
          onUploading={() => {
            this.setState({loading: true})
          }}
          onUploaded={file => {
            let value = {field: data.id, file: file.id};
            data.error = false
            data.answer = value
            this.props.onUpdated(index, value)
            this.setState({data})
          }}
          onRemoved={() => {
            data.answer.error = false
            data.answer.file = null
            this.props.onUpdated(index, data.answer)
            this.setState({data})
          }}
        />
        {
          data.error &&
          <FormHelperText>Please upload a file</FormHelperText>
        }
      </div>
    )
  }
}
